import React from 'react';
import customStyles from "../../../../../assets/styles/customStyles";
import clsx from "clsx";
import { Row, Col } from "antd";
import { SalesLines } from "./inc/Components";
import moment from 'moment';
import { currencyFormat, displayPan } from "../../../../../helpers/utilities";

export const Format9 = React.forwardRef((props, ref) => {
    const { businessDetails, details, preview, proformaPreview, copy } = props;
    const classes = customStyles();

    const address = (details) => {
        let address = details?.address || details?.address1 || '';
        address += address !== '' ? ', ' : '';
        address += details?.area && details?.area?.name ? details?.area?.name : '';
        return address;
    }

    const address1 = (details) => {
        let address = details?.city && details?.city?.name ? details?.city?.name + ' - ' : '---';
        address += details?.pincode && details?.pincode?.code ? details?.pincode?.code : '---';
        address += details?.state && details?.state?.name ? ', ' + details?.state?.name : '---';
        address += details?.country && details?.country?.name ? ', ' + details?.country?.name : '---';
        return address;
    }

    return (
        <>
            <div className={classes.formatseven}>
                <div className={classes.downloadtopbar}>
                    {
                        businessDetails?.logo && <div className={classes.downloadimages}>
                            <div className={clsx(classes.productImageUpload)}>
                                <div className={classes.productImageUploadInner}>
                                </div>
                            </div>
                        </div>
                    }
                    <div style={{ fontFamily: '"RobotoMedium", "Roboto"' }} className={clsx(classes.invoicehead)}>{proformaPreview ? 'Proforma' : preview || details?.invoiceAmount >= 0 ? `${details?.includeGst ? 'Tax Invoice' : 'Invoice'}` : 'Credit Note'}</div>
                    <div className={clsx(classes.bigBorder)}></div>
                </div>
                <div className={clsx(classes.downloadsecondbar, classes.padding30b)}>
                    <Row className={clsx(classes.alginitemNormal, classes.billCustom)}>
                        <Col xxl={24} xl={24} lg={24} md={24} sm={24} xs={24}>
                            <Row type="flex" gutter={15}>
                                <Col xxl={5} xl={5} lg={5} md={5} sm={5} xs={5} className={classes.dispalyIF}>
                                    <div className={clsx(classes.productImageUpload, classes.dropDown)}>
                                        <div className={classes.productImageUploadInner} style={{ display: "none" }}>
                                        </div>
                                    </div>
                                </Col>
                                <Col xxl={10} xl={10} lg={10} md={10} sm={10} xs={10}>
                                    <h1>{preview ? <span className={clsx(classes.greyBg, classes.smallWidth)}></span> : businessDetails?.businessName || details?.business?.name || '---'}</h1>
                                    <p>{preview ? <span className={clsx(classes.greyBg, classes.largeWidth)}></span> : address(businessDetails || details?.business)}</p>
                                    <p>{preview ? <span className={clsx(classes.greyBg, classes.mediumWidth)}></span> : address1(businessDetails || details?.business)}</p>
                                    <Row className={clsx(classes.bill, classes.margin15t)}>
                                        <Col span={24}>
                                            <Row>
                                                <Col span={3}>
                                                    <h6>Email</h6>
                                                </Col>
                                                <Col span={21}>
                                                    <p>{preview ? <span className={clsx(classes.greyBg, classes.mediumWidth)}></span> : businessDetails?.email || details?.business?.email || '---'}</p>
                                                </Col>
                                            </Row>
                                        </Col>
                                        <Col span={12}>
                                            <Row>
                                                <Col span={6}>
                                                    <h6>Ph No.</h6>
                                                </Col>
                                                <Col span={18}>
                                                    <p>{preview ? <span className={clsx(classes.greyBg, classes.mediumWidth)}></span> : businessDetails?.mobile || details?.business?.mobile || '---'}</p>
                                                </Col>
                                            </Row>
                                        </Col>
                                        {
                                            (details.includeGst || preview) && <Col span={12}>
                                                <Row className={classes.overlFlowResponsiveDesign}>
                                                    <Col span={6}>
                                                        <h6>GSTIN</h6>
                                                    </Col>
                                                    <Col span={18}>
                                                        <p>{preview ? <span className={clsx(classes.greyBg, classes.mediumWidth)}></span> : businessDetails?.gst || details?.business?.gstNumber || '---'}</p>
                                                    </Col>
                                                </Row>
                                            </Col>
                                        }
                                        {
                                            (businessDetails?.pan || details?.business?.panNumber) && <Col span={24}>
                                                <Row>
                                                    <Col span={3}>
                                                        <h6>{displayPan(businessDetails?.pan || details?.business?.panNumber || '')[0]}</h6>
                                                    </Col>
                                                    <Col span={21}>
                                                        <p>{preview ? <span className={clsx(classes.greyBg, classes.mediumWidth)}></span> : displayPan(businessDetails?.pan || details?.business?.panNumber || '')[1]}</p>
                                                    </Col>
                                                </Row>
                                            </Col>
                                        }
                                    </Row>
                                </Col>
                                <Col xxl={9} xl={9} lg={9} md={9} sm={9} xs={9} className={clsx(classes.textAlignRight, classes.marginBottom10, classes.bill)}>
                                    {proformaPreview ? '' : `${copy ? 'Duplicate Copy' : 'Original'}`}
                                    <div style={{ marginTop: 15 }}>
                                        <div>
                                            <h6 style={{ color: '#8a8a8e' }}>{preview || proformaPreview || details?.invoiceAmount >= 0 ? 'Invoice Number' : 'Credit Note'}</h6>
                                            <h1>{preview ? <span className={clsx(classes.greyBg, classes.mediumWidth)}></span> : details?.salesInvoice?.serialNo || details?.serialNo || '---'}</h1>
                                        </div>
                                        {
                                            details?.salesQuote?.serialNo && <div style={{ marginLeft: 20 }}>
                                                <h6>Reference</h6>
                                                <h1>{preview ? <span className={clsx(classes.greyBg, classes.mediumWidth)}></span> : details?.salesQuote?.serialNo || '---'}</h1>
                                            </div>
                                        }
                                    </div>
                                </Col>
                            </Row>
                        </Col>
                    </Row>
                </div>
                <Row className={clsx(classes.formatsevenbillrow)}>
                    <Col span={8} className={clsx(classes.formatsevenbillcol)}>
                        <div className={clsx(classes.bill)}>
                            <div className={clsx(classes.downloadsRectangle)}>
                                <Row>
                                    <Col span={12}>
                                        <Row>
                                            <Col span={24}>
                                                <h6>Invoice Date</h6>
                                            </Col>
                                            <Col span={24}>
                                                <p>{preview ? <span className={clsx(classes.greyBg, classes.smallWidth)}></span> : details?.invoiceDate ? moment(details.invoiceDate).format('DD MMM YYYY') : '---'}</p>
                                            </Col>
                                        </Row>
                                    </Col>
                                    <Col span={12}>
                                        <Row>
                                            <Col span={24}>
                                                <h6>Due Date</h6>
                                            </Col>
                                            <Col span={24}>
                                                <p>{preview ? <span className={clsx(classes.greyBg, classes.smallWidth)}></span> : details?.dueDate ? moment(details.dueDate).format('DD MMM YYYY') : '---'}</p>
                                            </Col>
                                        </Row>
                                    </Col>
                                    <Col span={12}>
                                        <Row>
                                            <Col span={24} className={clsx(classes.paddingTop15)}>
                                                <h6>Pmt. Method</h6>
                                            </Col>
                                            <Col span={24}>
                                                <p>{preview ? <span className={clsx(classes.greyBg, classes.smallWidth)}></span> : details?.mop?.method || '---'}</p>
                                            </Col>
                                        </Row>
                                    </Col>
                                    <Col span={12}>
                                        <Row>
                                            <Col span={24} className={clsx(classes.paddingTop15)}>
                                                <h6>Currency</h6>
                                            </Col>
                                            <Col span={24}>
                                                <p>{preview ? <span className={clsx(classes.greyBg, classes.smallWidth)}></span> : details?.currency?.name || '---'}</p>
                                            </Col>
                                        </Row>
                                    </Col>
                                </Row>
                                <div style={{ fontFamily: '"RobotoMedium", "Roboto"' }} className={clsx(classes.downloadsHeading, classes.margin20t, classes.marginBottom10)}>Totals</div>
                                <Row>
                                    <Col span={12}>
                                        <Row>
                                            <Col span={24}>
                                                <h6>Invoice Amount</h6>
                                            </Col>
                                            <Col span={24}>
                                                <p>{preview ? <span className={clsx(classes.greyBg, classes.smallWidth)}></span> : `${currencyFormat(details?.invoiceAmount ? details?.invoiceAmount : 0)}`}</p>
                                            </Col>
                                        </Row>
                                    </Col>
                                    {
                                        (details.includeGst || preview) && <Col span={12}>
                                            <Row>
                                                <Col span={24} >
                                                    <h6>GST Amount</h6>
                                                </Col>
                                                <Col span={24}>
                                                    <p>{preview ? <span className={clsx(classes.greyBg, classes.smallWidth)}></span> : `${currencyFormat(details?.selfBillItems ? details?.selfBillItems.reduce((a, v) => a = parseFloat(a) + parseFloat(v.gstAmount), 0) : 0)}`}</p>
                                                </Col>
                                            </Row>
                                        </Col>
                                    }
                                    <Col span={12}>
                                        <Row>
                                            <Col span={24} className={clsx({ [classes.paddingTop15]: (details.includeGst || preview) })}>
                                                <h6>Discount</h6>
                                            </Col>
                                            <Col span={24}>
                                                <p>{preview ? <span className={clsx(classes.greyBg, classes.smallWidth)}></span> : `${currencyFormat(details?.selfBillItems ? parseFloat(details.selfBillItems.reduce((a, v) => a = parseFloat(a) + (v.discountAmount ? parseFloat(v.discountAmount) : 0), 0)) + parseFloat(details.selfBillItems.reduce((a, v) => a = parseFloat(a) + parseFloat(((v.quantity * v.pricePerUnit) * v.discountPercent) / 100), 0)) : 0)}`}</p>
                                            </Col>
                                        </Row>
                                    </Col>
                                    <Col span={12}>
                                        <Row>
                                            <Col span={24} className={clsx(classes.paddingTop15)}>
                                                <h6>Net Amount</h6>
                                            </Col>
                                            <Col span={24}>
                                                <p>{preview ? <span className={clsx(classes.greyBg, classes.smallWidth)}></span> : `${currencyFormat(details?.selfBillItems ? details?.invoiceAmount - details?.selfBillItems.reduce((a, v) => a = parseFloat(a) + parseFloat(v.gstAmount), 0) : 0)}`}</p>
                                            </Col>
                                        </Row>
                                    </Col>
                                </Row>
                            </div>
                        </div>
                    </Col>
                    <Col span={16} className={clsx(classes.formatsevenbillcol, classes.paleblueborder, classes.padding15L)}>
                        <Row gutter={30}>
                            <Col span={12} className={clsx(classes.bill, classes.billtoppadding)}>
                                <h6>Bill To</h6>
                                <p>{preview ? <span className={clsx(classes.greyBg, classes.smallWidth)}></span> : details?.name || details?.customerName || '---'}</p>
                                <p>{preview ? <span className={clsx(classes.greyBg, classes.largeWidth)}></span> : address(details?.customer)}</p>
                                <p>{preview ? <span className={clsx(classes.greyBg, classes.mediumWidth)}></span> : address1(details?.customer)}</p>
                            </Col>
                            <Col span={12} className={clsx(classes.bill, classes.billtoppadding)}>
                                <h6>Shipped To</h6>
                                <p>{preview ? <span className={clsx(classes.greyBg, classes.smallWidth)}></span> : details?.name || details?.customerName || '---'}</p>
                                <p>{preview ? <span className={clsx(classes.greyBg, classes.largeWidth)}></span> : address(details)}</p>
                                <p>{preview ? <span className={clsx(classes.greyBg, classes.mediumWidth)}></span> : address1(details)}</p>
                            </Col>
                            <Col span={12} className={clsx(classes.bill, classes.billbottompadding)}>
                                <Row>
                                    {
                                        (details.includeGst || preview) && <Col span={24}>
                                            <Row>
                                                <Col span={5}>
                                                    <h6>GSTIN</h6>
                                                </Col>
                                                <Col span={19}>
                                                    <p>{preview ? <span className={clsx(classes.greyBg, classes.mediumWidth)}></span> : details?.customer?.gstin || '---'}</p>
                                                </Col>
                                            </Row>
                                        </Col>
                                    }
                                    <Col span={24} className={clsx(classes.marginBottom20)}>
                                        <Row>
                                            <Col span={5}>
                                                <h6>Ph No.</h6>
                                            </Col>
                                            <Col span={19}>
                                                <p>{preview ? <span className={clsx(classes.greyBg, classes.mediumWidth)}></span> : details?.customer?.mobile || '---'}</p>
                                            </Col>
                                        </Row>
                                    </Col>
                                    <Col span={24}>
                                        <Row>
                                            <Col span={5}>
                                                <h6>Email</h6>
                                            </Col>
                                            <Col span={19}>
                                                <p className={clsx(classes.emailText)}>{preview ? <span className={clsx(classes.greyBg, classes.mediumWidth)}></span> : details?.customer?.email || '---'}</p>
                                            </Col>
                                        </Row>
                                    </Col>
                                    {
                                        details?.customer?.pan && <Col span={24}>
                                            <Row>
                                                <Col span={5}>
                                                    <h6>{displayPan(details?.customer?.pan)[0]}</h6>
                                                </Col>
                                                <Col span={19}>
                                                    <p>{preview ? <span className={clsx(classes.greyBg, classes.mediumWidth)}></span> : displayPan(details?.customer?.pan)[1]}</p>
                                                </Col>
                                            </Row>
                                        </Col>
                                    }
                                </Row>
                            </Col>
                            <Col span={12} className={clsx(classes.bill, classes.billbottompadding)}>
                                <Row>
                                    {
                                        (details.includeGst || preview) &&
                                        <Col span={24}>
                                            <Row>
                                                <Col span={5}>
                                                    <h6>GSTIN</h6>
                                                </Col>
                                                <Col span={19}>
                                                    <p>{preview ? <span className={clsx(classes.greyBg, classes.mediumWidth)}></span> : details?.customer?.gstin || '---'}</p>
                                                </Col>
                                            </Row>
                                        </Col>
                                    }
                                    <Col span={24} className={clsx(classes.marginBottom20)}>
                                        <Row>
                                            <Col span={5}>
                                                <h6>Ph No.</h6>
                                            </Col>
                                            <Col span={19}>
                                                <p>{preview ? <span className={clsx(classes.greyBg, classes.mediumWidth)}></span> : details?.phone || '---'}</p>
                                            </Col>
                                        </Row>
                                    </Col>
                                    <Col span={24}>
                                        <Row>
                                            <Col span={5}>
                                                <h6>Email</h6>
                                            </Col>
                                            <Col span={19}>
                                                <p className={clsx(classes.emailText)}>{preview ? <span className={clsx(classes.greyBg, classes.mediumWidth)}></span> : details?.email || '---'}</p>
                                            </Col>
                                        </Row>
                                    </Col>
                                    {
                                        details?.customer?.pan && <Col span={24}>
                                            <Row>
                                                <Col span={5}>
                                                    <h6>{displayPan(details?.customer?.pan)[0]}</h6>
                                                </Col>
                                                <Col span={19}>
                                                    <p>{preview ? <span className={clsx(classes.greyBg, classes.mediumWidth)}></span> : displayPan(details?.customer?.pan)[1]}</p>
                                                </Col>
                                            </Row>
                                        </Col>
                                    }
                                </Row>
                            </Col>
                        </Row>
                    </Col>
                </Row>
                <div className={clsx(classes.PlaceofSupply, classes.customForm9)}>Place of Supply
                    <span className={classes.PlaceofSupplyText}>{details?.state?.name}</span></div>
                <div className={clsx(classes.thirdSection)}>
                    <SalesLines ref={ref} {...props} terms={true} />
                </div>
            </div>
        </>
    )
})